
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-linecap":"round","stroke-width":"1.5","stroke":"#000","fill":"none","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M23.25 12.75l-10.47 10.5M17.25 12.751h6v5.99M18.75.75v4.5h-6v6h-6v6h-6v6"}})])])
          )
        }
      }
    